import { useEffect, useRef } from 'react';

import { useLocation } from 'react-router-dom';

import gtmTracker from '@utils/gtmTracker';

export const useGtmPageView = () => {
	const location = useLocation();
	const lastPathname = useRef<string>('');

	useEffect(() => {
		if (lastPathname.current !== location.pathname) {
			lastPathname.current = location.pathname;
			gtmTracker.trackPageView();
		}
	}, [location.pathname]);
};
